import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "small", "strong", "strikeThrough", "underline", "inline", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Polymorphic component for rendering paragraphs.
 */
export var Paragraph = function Paragraph(_ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'p' : _ref$as,
      small = _ref.small,
      strong = _ref.strong,
      strikeThrough = _ref.strikeThrough,
      underline = _ref.underline,
      inline = _ref.inline,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Component, _objectSpread({
    className: classNames('p', {
      small: small,
      strong: strong,
      underline: underline,
      'strike-through': strikeThrough,
      'm-0': inline
    }, className)
  }, rest));
};